import { request } from '@umijs/max';
import { getAdminApiUrl } from '@/services/util';

export interface AppearanceInfo {
  /** 品牌标识文本 */
  brandIdentifier?: string;
  /** 控制台页面标题 */
  consoleTitle?: string;
  /** 管理端页面标题 */
  adminTitle?: string;
  /** 主题色 */
  primaryColor?: string;
  systemFaviconFileId?: string;
  loginPageLogoFileId?: string;
  loginPageBackgroundFileId?: string;
  systemLogoFileId?: string;
  systemFaviconFile?: { url?: string };
  loginPageLogoFile?: { url?: string };
  loginPageBackgroundFile?: { url?: string };
  systemLogoFile?: { url?: string };
}

// 获取品牌外观配置
export async function getAppearance(options?: { [key: string]: unknown }) {
  return request<AppearanceInfo>(getAdminApiUrl('branding/current'), {
    method: 'POST',
    data: {},
    ...(options || {}),
  });
}
